import { Injectable } from '@angular/core';

import { AppServiceCommand } from '../../models/app-service-command.model';
import { AppServiceResponse } from '../../models/app-service-response.model';
import { OfficeAppService } from '../../models/office-app-service.interface';
import { AppServiceConnection } from '../app-service-connection.service';
import { PwaConfigService, PwaMockConfig } from '../pwa-config.service';

/**
 * Mock App Service Connection.
 */
@Injectable()
export class MockAppServiceConnection implements AppServiceConnection {

    private appService: OfficeAppService;
    private readonly mockConfig: PwaMockConfig;

    constructor(pwaConfigService: PwaConfigService) {
        this.mockConfig = pwaConfigService.config.mock || {};
    }

    public async sendCommands(commands: Array<AppServiceCommand>): Promise<AppServiceResponse> {
        const appService = await this.getMockAppService();
        return appService.execute(commands);
    }

    private getMockAppService(): Promise<OfficeAppService> {
        if (this.appService) {
            return Promise.resolve(this.appService);
        }

        return import(/* webpackChunkName: "mock-app-service" */ './mock-office-app-service.mock').then(module => {
            this.appService = new module.MockOfficeAppService(this.mockConfig);
            return this.appService;
        });
    }
}
